import * as React from "react";
import {
    addTransaction,
    getAllExpenseType,
    getAllUnits,
    getContractByProperty,
    updateTransaction,
} from "state/apis";
import {
    TextField,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    useTheme,
    IconButton,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { useState } from "react";
import { Close as CloseIcon } from "@mui/icons-material";

const AddExpense = ({ open, onClose, onSubmit, editData, editMode, property }) => {
    const theme = useTheme();
    const [data, setData] = React.useState([]);
    const [units, setFlat] = useState([]);
    const defaultProperty = localStorage.getItem("propertyId");
    const [request, setRequest] = React.useState({
        expenseType: null,
        amount: 0,
        date: dayjs(),
        billNumber: "",
        remarks: "",
        description: "",
        type: "debit",
        propertyId: defaultProperty || null,
        unitId: null,
        contractId: null,
        attachment: "",
        docName: "",
    });

    React.useEffect(() => {
        if (request.propertyId && request.unitId) {
            fetchContract();
        }
    }, [request?.propertyId, request?.unitId]);

    const fetchUnit = async (id) => {
        const res = await getAllUnits(100, 0, "", id);
        setFlat(res.data);
    };

    React.useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await getAllExpenseType(10000, 0);
                setData(res?.data);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchUnit(defaultProperty);
        if (editData) {
            fetchUnit(editData?.propertyId);
            setRequest((prevData) => ({
                ...prevData,
                expenseType: editData?.expenseType,
                amount: editData?.amount,
                date: editData?.date,
                billNumber: editData?.billNumber,
                remarks: editData?.remarks || "",
                type: editData?.type,
                propertyId: editData?.propertyId || null,
                unitId: editData?.unitId || null,
                attachment: editData?.attachment || "",
                docName: editData?.docName || "",
                description: editData?.description || "",
            }));
        }
        fetchData();
    }, [editData, editMode]);

    const handleExpenseChange = (newValue) => {
        setRequest((prevData) => ({
            ...prevData,
            expenseType: newValue ? newValue.id : null,
        }));
    };

    const handleDateChange = (date) => {
        const formattedDate = date.format("YYYY-MM-DD");
        setRequest((prevData) => ({
            ...prevData,
            date: date ? formattedDate : "",
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log("name, value: ", name, value);
        setRequest((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const handleSubmit = async () => {
        try {
            if (!request.expenseType) {
                return toast.error("Please select expense type");
            }
            if (editMode) {
                const response = await updateTransaction(editData.id, request);
                console.log("request: ", request);
                toast.success(response.message);
                setFlat([]);
            } else {
                const response = await addTransaction(request);
                toast.success(response.message);
                setFlat([]);
            }

            setRequest((prevData) => ({
                ...prevData,
                chequeId: null,
                contractId: null,
                expenseType: null,
                amount: 0,
                date: dayjs(),
                billNumber: "",
                bankRefNumber: "",
                transactionType: "",
                remarks: "",
                description: "",
                type: "debit",
                propertyId: defaultProperty || null,
                attachment: "",
                docName: "",
            }));
            setFlat([]);
            onSubmit();
            onClose();
        } catch (error) {
            console.error("Error:", error);
            if (error.response) {
                toast.error(error.response.data.message);
            } else if (error.request) {
                toast.error("No response received from server.");
            } else {
                toast.error("An error occurred. Please try again.");
            }
        }
    };

    const handlePropertyChange = (newValue) => {
        setRequest((prevData) => ({
            ...prevData,
            propertyId: newValue ? newValue.id : null,
        }));
        if (newValue !== null) {
            fetchUnit(newValue.id);
        }
        setFlat([]);
    };
    const handleUnitChange = (newValue) => {
        setRequest((prevData) => ({
            ...prevData,
            unitId: newValue ? newValue.id : null,
        }));
    };

    const handleDocChange = (e) => {
        const file = e.target.files[0];
        setRequest((prevData) => ({
            ...prevData,
            attachment: file,
        }));
    };

    const fetchContract = async () => {
        try {
            const res = await getContractByProperty({
                propertyId: request?.propertyId,
                unitId: request?.unitId,
                closed: false,
            });
            if (res.contract.length) {
                setRequest((prevState) => ({
                    ...prevState,
                    contractId: res.contract[0].id,
                }));
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleDialogClose = () => {
        setRequest((prevData) => ({
            ...prevData,
            chequeId: null,
            contractId: null,
            expenseType: null,
            amount: 0,
            date: dayjs(),
            billNumber: "",
            bankRefNumber: "",
            transactionType: "",
            remarks: "",
            description: "",
            type: "debit",
            propertyId: defaultProperty || null,
            attachment: "",
            docName: "",
        }));
        setFlat([]);
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleDialogClose} fullWidth maxWidth={"md"}>
            {/* <DialogTitle sx={{ textAlign: "center", fontWeight: "900", mb: "2px" }}>
                {editMode ? "Edit Expense" : "Add Expense"}
            </DialogTitle> */}
            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontWeight: "bold",
                    marginLeft: "6px",
                }}
            >
                {editMode ? "Edit Expense" : "Add Expense"}
                <IconButton onClick={handleDialogClose} sx={{ color: "inherit" }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={3} p={"5px"}>
                    <Grid item xs={6}>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={property}
                            getOptionLabel={(option) => option.propertyName}
                            value={
                                defaultProperty
                                    ? property.find((pro) => pro.id == defaultProperty) || null
                                    : null
                            }
                            onChange={(event, newValue) => handlePropertyChange(newValue)}
                            isOptionEqualToValue={(option, value) => option === value}
                            getOptionDisabled={(option) => option.id != defaultProperty}
                            renderOption={(props, option) => (
                                <li {...props} key={option.id}>
                                    {option.propertyName}
                                </li>
                            )}
                            sx={{
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                    "&.Mui-focused fieldset": {
                                        borderColor: "primary.main",
                                    },
                                },
                                "& .MuiInputLabel-root": {
                                    "&.Mui-focused": {
                                        color: "primary.main",
                                    },
                                },
                            }}
                            renderInput={(params) => (
                                <TextField {...params} fullWidth label="Select Property" />
                            )}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={units}
                            getOptionLabel={(option) => option.unitNumber}
                            value={
                                request?.unitId
                                    ? units.find((unit) => unit.id === request?.unitId)
                                    : null
                            }
                            onChange={(event, newValue) => handleUnitChange(newValue)}
                            isOptionEqualToValue={(option, value) => option === value}
                            renderOption={(props, option) => (
                                <li {...props} key={option.id}>
                                    {option.unitNumber}
                                </li>
                            )}
                            sx={{
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                    "&.Mui-focused fieldset": {
                                        borderColor: "primary.main",
                                    },
                                },
                                "& .MuiInputLabel-root": {
                                    "&.Mui-focused": {
                                        color: "primary.main",
                                    },
                                },
                            }}
                            renderInput={(params) => (
                                <TextField {...params} fullWidth label="Select Unit" />
                            )}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={data}
                            getOptionLabel={(option) => option.name}
                            value={
                                request?.expenseType
                                    ? data.find((val) => val.id === request?.expenseType)
                                    : null
                            }
                            onChange={(event, newValue) => handleExpenseChange(newValue)}
                            isOptionEqualToValue={(option, value) => option === value}
                            renderOption={(props, option) => (
                                <li {...props} key={option.id}>
                                    {option.name}
                                </li>
                            )}
                            sx={{
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                    "&.Mui-focused fieldset": {
                                        borderColor: "primary.main",
                                    },
                                },
                                "& .MuiInputLabel-root": {
                                    "&.Mui-focused": {
                                        color: "primary.main",
                                    },
                                },
                            }}
                            renderInput={(params) => (
                                <TextField {...params} fullWidth label="Select Expense" />
                            )}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} color="primary">
                            <DatePicker
                                label="Select transaction date"
                                name="date"
                                value={request?.date ? dayjs(request?.date) : null}
                                onChange={handleDateChange}
                                format="DD/MM/YYYY"
                                disabled={true}
                                sx={{
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        "&.Mui-focused fieldset": {
                                            borderColor: "primary.main",
                                        },
                                    },
                                    "& .MuiInputLabel-root": {
                                        "&.Mui-focused": {
                                            color: "primary.main",
                                        },
                                    },
                                }}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Bill Number"
                            name="billNumber"
                            value={request?.billNumber}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            color="primary"
                            label="Amount"
                            type="number"
                            name="amount"
                            value={request?.amount}
                            InputLabelProps={{
                                sx: { marginBottom: 1 },
                            }}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Description"
                            variant="outlined"
                            multiline
                            fullWidth
                            color="primary"
                            rows={4}
                            value={request?.description}
                            name="description"
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Remark"
                            variant="outlined"
                            multiline
                            fullWidth
                            color="primary"
                            rows={4}
                            value={request?.remarks}
                            name="remarks"
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={5}>
                                <TextField
                                    fullWidth
                                    color="primary"
                                    label="Document Name"
                                    name="docName"
                                    value={request?.docName}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={5} margin={"auto"}>
                                <input
                                    type="file"
                                    accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                    onChange={(e) => handleDocChange(e)}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        {request?.attachment && editMode && (
                            <div style={{ marginBottom: "8px" }}>
                                {/* Display the document link if present */}
                                <a
                                    href={request.attachment}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        textDecoration: "none",
                                        color: "#1976d2",
                                        fontWeight: "bold",
                                    }}
                                >
                                    View Document
                                </a>
                            </div>
                        )}
                    </Grid>
                </Grid>
                <DialogActions
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: theme.spacing(2),
                    }}
                >
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        sx={{
                            color: theme.palette.primary,
                            backgroundColor: theme.palette.primary[800],
                        }}
                    >
                        Save
                    </Button>
                    {/* <Button
                        variant="contained"
                        // onClick={handleSubmit}
                        sx={{
                            color: theme.palette.primary.light,
                            backgroundColor: theme.palette.secondary[200],
                        }}
                    >
                        Print
                    </Button> */}
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

export default AddExpense;
